<template>
  <div class="d-flex">
    <v-btn
      :color="color"
      class="primary"
      :disabled="disabled"
      :id="`${elementId}-primary`"
      :style="{ borderRadius: buttonRadius }"
      small
      text
      @click="$emit('primary')"
    >
      <Icon
      v-if="icon"
      :icon="icon"
      :small="false"
      margin="mr-1"
      icon-color="white"/>
      <span :class="buttonClass">{{ label }}</span>
    </v-btn>
    <v-menu offset-y open-on-hover v-if="!hideChevron">
      <template #activator="{ on }">
        <v-btn
          :color="color"
          :disabled="disabled"
          :id="`${elementId}-chevron`"
          class="px-1 primary dropdown-chevron"
          style="min-width: 32px; border-radius: 0 4px 4px 0; margin-left: -1px; opacity: 0.8"
          small
          text
          v-on="on"
        >
          <Icon
          icon="mdi-menu-down"
          :small="false"
          icon-color="white"/>
        </v-btn>
      </template>
      <v-list dense color="grey lighten-4">
        <slot name="menu"/>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'SplitButton',
  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: 'primary'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    elementId: {
      type: String,
      default: 'split-button'
    },
    hideChevron: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    buttonRadius () {
      return this.hideChevron ? '4px' : '4px 0 0 4px'
    },

    buttonClass () {
      return this.hideChevron ? 'white--text mr-3' : 'white--text'
    }
  }
}
</script>
